import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import DeviceDetailMobile from './DeviceDetailMobile'
import DeviceDetail from './DeviceDetail'


interface Props {
    classes: {
        cardTitleWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: string;
        };
        search: string;
    };

}


const DeviceDetailsWrapper:React.FC<Props> = (props) => {
    const isMobile = useMobileContext()
    return isMobile ? <DeviceDetailMobile {...props} /> : <DeviceDetail {...props} />
}

export default DeviceDetailsWrapper